// extracted by mini-css-extract-plugin
export default {"nav_links":"Navigation_nav_links__qM9sK","nav_item":"Navigation_nav_item__mumiV"};